<script>
// api
import forEach from 'lodash/forEach'
import { resizeImage } from '~/util/img.util'
import { latestNews } from '~/api/project.api'
import ImgGrid from '~/components/ImgGrid'

export default {
  components: {
    ImgGrid
  },
  props: {
    width: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      imageList: [
        'https://media-dev.1qizhuang.com/dev/bgw/83639022?x-oss-process=image/resize,m_fill,w_217,h_217,limit_0/auto-orient,1/quality,q_90',
        'https://media-dev.1qizhuang.com/dev/bgw/83639022?x-oss-process=image/resize,m_fill,w_217,h_217,limit_0/auto-orient,1/quality,q_90',
        'https://media-dev.1qizhuang.com/dev/bgw/83639022?x-oss-process=image/resize,m_fill,w_217,h_217,limit_0/auto-orient,1/quality,q_90',
        'https://media-dev.1qizhuang.com/dev/bgw/83639022?x-oss-process=image/resize,m_fill,w_217,h_217,limit_0/auto-orient,1/quality,q_90'
      ],
      eventList: [],
      pageNo: 1,
      pageSize: 6,
      isLoading: false,
      isLastPage: false
    }
  },
  created() {
    this.getLastestNews()
  },
  methods: {
    getLastestNews,
    itemWidthClass,
    loadMore,
    resizeImage
  }
}

function itemWidthClass(event) {
  const imageList = event.newPhotoListOssUrl
  let returnClass = ''
  if (imageList.length === 1) {
    event.itemWidth = this.width
    event.itemHeight = (this.width / 16) * 9
    returnClass = 'full_width_image'
  } else if (imageList.length === 2 || imageList.length === 4) {
    event.itemHeight = (this.width - 15) / 2
    event.itemWidth = event.itemHeight
    returnClass = 'double_width_image'
  } else {
    event.itemHeight = (this.width - 25) / 3
    event.itemWidth = event.itemHeight
    returnClass = 'more_width_image'
  }
  if (!event.resized) {
    const previewList = []
    forEach(event.newPhotoListOssUrl, (imageItem) => {
      previewList.push(imageItem.photoOssUrl)
      imageItem.photoOssUrl = resizeImage({
        src: imageItem.photoOssUrl,
        width: event.itemWidth,
        height: event.itemHeight
      })
    })
    event.previewList = previewList
    event.resized = true
  }
  return returnClass
}

function loadMore() {
  if (this.isLoading || this.isLastPage) return false
  this.pageNo++
  this.isLoading = true
  this.getLastestNews()
}

async function getLastestNews() {
  const res = await latestNews({
    pageNo: this.pageNo,
    pageSize: this.pageSize,
    projectId: this.$route.params.projectId
  })
  const eventList = res.data
  this.eventList = this.eventList.concat(eventList)
  if (eventList.length < this.pageSize) {
    this.isLastPage = true
  }
  this.isLoading = false
}
</script>
<template>
  <div class="project_event_list_container">
    <ul>
      <li
        v-for="event in eventList"
        :key="event.targetId"
        class="project_event_list_item_container bottom_line_L_R_70"
      >
        <img :src="event.imgUrlOssUrl" class="head_image" />
        <div v-if="event.top === 'Y'" class="project_event_top">
          <img :src="$_yqzResource.icon.upRedArrow" />
          <span>置顶</span>
        </div>
        <div class="project_event_list_right_container">
          <span class="project_author_name">{{ event.nickName }}</span>
          <span class="project_role_name">{{ event.roleName }}</span>
          <!-- prettier-ignore -->
          <p v-show="event.comment" class="project_update"
          >{{ event.comment }}</p>
          <div class="project_event_list_image_container">
            <ImgGrid :width="width" :images="event.newPhotoListOssUrl" />
          </div>
          <span class="event_time">{{ event.eventTime }}</span>
        </div>
      </li>
    </ul>
    <button v-if="!isLastPage" @click="loadMore" class="more_events">
      查看更多工地动态
    </button>
  </div>
</template>
<style lang="scss">
.bottom_line_L_R_70 {
  position: relative;
}
.bottom_line_L_R_70::after {
  position: absolute;
  bottom: 0px;
  left: 70px;
  right: 0;
  display: block;
  background: #eff1f2;
  content: '';
  height: 1px;
  transform: scale(1, 0.5);
  -webkit-transform: scale(1, 0.5);
}

.project_event_list_container {
  * {
    margin: 0;
    padding: 0;
  }

  .project_update {
    padding-bottom: 10px;
    white-space: pre-wrap;
  }

  .more_events {
    background: white;
    padding: 15px 0;
    text-align: center;
    margin-left: 70px;
    width: calc(100% - 70px);
    font-size: 14px;
    color: rgba(68, 68, 68, 1);
    display: block;
    line-height: 14px;
    cursor: pointer;
    border: 1px solid rgba(239, 241, 242, 1);
  }

  .project_event_list_item_container {
    display: flex;
    position: relative;
    padding-bottom: 25px;
    padding-top: 25px;

    .project_event_top {
      position: absolute;
      display: flex;
      align-items: center;
      top: 33px;
      right: 0;
      font-size: 14px;
      color: rgba(255, 89, 89, 1);
      line-height: 14px;

      img {
        width: 12px;
        height: 14px;
        margin-right: 5px;
      }
    }

    .head_image {
      width: 55px;
      height: 55px;
      border-radius: 100%;
      margin-right: 15px;
    }

    .project_event_list_right_container {
      width: 100%;
      padding-top: 8px;

      p {
        font-size: 16px;
        color: rgba(68, 68, 68, 1);
        line-height: 20px;
      }

      .project_role_name {
        display: block;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 14px;
        color: rgba(155, 155, 155, 1);
        line-height: 14px;
      }

      .project_author_name {
        font-weight: bold;
        display: block;
        font-size: 16px;
        color: rgba(42, 42, 42, 1);
        line-height: 16px;
      }
      .project_event_list_image_container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        $image_margin_top: 5px;
        $image_margin_right: 5px;

        //3,5,6,7,8,9张图片
        .more_width_image {
          // width: 32%;
          margin-right: $image_margin_right;
          margin-top: $image_margin_top;
        }

        //1张图片
        .full_width_image {
          padding-top: 5px;
          // width: 100%;
        }

        //2张4张图片
        .double_width_image {
          // width: 49%;
          margin-right: $image_margin_right;
          margin-top: $image_margin_top;
        }
      }
    }

    .event_time {
      display: block;
      font-size: 14px;
      color: rgba(155, 155, 155, 1);
      line-height: 14px;
      padding-top: 10px;
    }
  }
}

@media screen and (max-width: 940px) {
  .project_event_list_item_container {
    padding-bottom: 15px !important;
  }
  .project_event_list_container {
    width: 100%;
    padding: 0px 15px 0 0;
    .project_event_list_item_container {
      .head_image {
        width: 40px;
        height: 40px;
      }
    }
    .more_events {
      background: white;
      padding: 15px 0;
      text-align: center;
      margin-left: 0px;
      width: 100%;
      font-size: 14px;
      color: rgba(68, 68, 68, 1);
      display: block;
      line-height: 14px;
      cursor: pointer;
      border: 1px solid rgba(239, 241, 242, 1);
    }
  }
}
</style>
